import { useState } from 'react'
import { Post, AddressData } from '@wellesley/openapi'

const useLocationControl = (feed?: Post) => {
  const [location, setLocation] = useState<AddressData | null>(
    feed?.address ?? null,
  )

  const clearLocation = () => setLocation(null)

  return {
    location,
    setLocation,
    clearLocation,
  }
}

export default useLocationControl
